module.exports = __webpack_public_path__ + "img/us_xhs.ea035fb.webp";